<template>
  <Section title="Uprawnienia">
    <b-table :items="permissionsTable" :fields="permissionsTableFields" hover>
      <template v-slot:cell(permission)="data">
        <Icon :name="data.item.permission ? 'check' : 'times'" />
      </template>
    </b-table>
  </Section>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserPermissions",
  data() {
    return {
      permissionsTableFields: [
        {
          key: "name",
          label: "Uprawnienie"
        },
        {
          key: "permission",
          label: "",
          tdClass: "user-permissions__td-permission"
        }
      ]
    };
  },
  computed: {
    ...mapState("Account", ["account"]),
    permissionsTable() {
      return [
        {
          name: "Administrator",
          permission: this.account.permissions.eventAdmin
        },
        {
          name: "Dodawanie wydarzeń",
          permission: this.account.permissions.eventNew
        },
        {
          name: "Edycja wydarzeń",
          permission: this.account.permissions.eventSave
        },
        {
          name: "Podgląd wydarzeń",
          permission: this.account.permissions.eventList
        },
        {
          name: "Usuwanie wydarzeń",
          permission: this.account.permissions.eventDelete
        }
      ].filter(item => item.permission);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

.user-permissions__td-permission {
  width: 50px;
  .icon-check {
    fill: $col-polmed-green;
  }
  .icon-times {
    fill: $col-polmed-red;
  }
}
</style>
